import { DatePipe } from '@angular/common';

export class PaymentVersion {
    public created_at_iso: string;
    public change_set = {};
    public booking_event: string;
    public first_name: string;
    public last_name: string;
    public photo_url: string;
    public model: string;
    public object_id: number;

    booking_event_formatted() {
        return this.booking_event[0].toUpperCase() + this.booking_event.substring(1) + 'd by';
    };

    full_name() {
        return this.first_name + ' ' + this.last_name;
    };

    change_set_formatted_hash() {
        let changeset_hash = this.change_set;

        if (this.booking_event === 'create') {
            return [];
        }

        delete changeset_hash['created_at'];
        delete changeset_hash['updated_at'];
        delete changeset_hash['bookable_type'];
        delete changeset_hash['bookable_id'];
        delete changeset_hash['assignment_type_id'];

        let formatted_hash = [];
        let changesetTimeKeys = ['interpreting_time', 'preparation_time', 'travel_time', 'interpreting_time_weekend'];

        for (let key of Object.keys(changeset_hash)) {
            let formatted_key = this.remove_underscores_and_capitilise_each_word(key);

            let first_hash_value = changeset_hash[key][0];
            let second_hash_value = changeset_hash[key][1];

            if ( first_hash_value ===  null || (Object.keys(first_hash_value).length === 0) ) {
                first_hash_value = (first_hash_value === false || first_hash_value === true) ?
                    first_hash_value : '[blank]';
            }

            if ( second_hash_value ===  null || (Object.keys(second_hash_value).length === 0) ) {
                second_hash_value = (second_hash_value === false || second_hash_value === true) ?
                second_hash_value : '[blank]';
            }

            let formatted_value;
            if (typeof first_hash_value === 'object' || typeof second_hash_value === 'object') {
                formatted_value = [this.remove_underscores_and_capitilise_each_word(JSON.stringify(first_hash_value)),
                     this.remove_underscores_and_capitilise_each_word(JSON.stringify(second_hash_value))];
            } else {
                formatted_value = [first_hash_value.toString(), second_hash_value.toString()];
            }

            let date_pipe = new DatePipe('en-AU');

            if (key === 'start_time' || key === 'end_time') {
                let iso_time_from = new Date(formatted_value[0]).toISOString();
                let iso_time_to = new Date(formatted_value[1]).toISOString();
                let formatted_value_from = date_pipe.transform(iso_time_from, 'shortTime') + ' on ' + date_pipe.transform(iso_time_from, 'EEE d MMM yy');
                let formatted_value_to = date_pipe.transform(iso_time_to, 'shortTime') + ' on ' + date_pipe.transform(iso_time_to, 'EEE d MMM yy');

                formatted_value = [formatted_value_from, formatted_value_to];
            } else if (changesetTimeKeys.includes(key)) {
                let interpretingTimeFrom = this.formatNumbersToHoursAndMinutes(formatted_value[0]);
                let interpretingTimeTo = this.formatNumbersToHoursAndMinutes(formatted_value[1]);
                formatted_value = [interpretingTimeFrom, interpretingTimeTo];
            } else if (key === 'distance') {
                let distanceFrom = this.formatMetersToKilometersAndMeters(formatted_value[0]);
                let distanceTo = this.formatMetersToKilometersAndMeters(formatted_value[1]);
                formatted_value = [distanceFrom, distanceTo];
            }
            formatted_hash.push([formatted_key, formatted_value]);
        };

        return formatted_hash;
    }

    remove_underscores_and_capitilise_each_word(unformatted_string) {
        return unformatted_string
            .replace(/_/g, ' ').replace(/[{"\}/]/g, '').replace(/,/g, ', ')
            .replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };

    formatNumbersToHoursAndMinutes(total_minutes) {
        let hours = parseInt((total_minutes / 60).toString(), 10);
        let minutes = total_minutes % 60;
        let formattedMinutes = minutes < 10 ? '0' + minutes + '' : minutes;
        return '' + hours + ':' + formattedMinutes;
    }

    formatMetersToKilometersAndMeters(total_meters) {
        let kilometers = parseInt((total_meters / 1000).toString(), 10);
        let meters = total_meters % 1000;
        let formattedDistance = meters > 0 ? '' + kilometers + '.' + meters : kilometers;
        return formattedDistance;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/payment-version.entity.ts